module.exports = __webpack_public_path__ + "static/media/3.538840b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/3.png
// module id = 939
// module chunks = 0